import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { HEADER_SELECT_STYLES } from "./date-field-styles";
import { TIME_OPTIONS, isValidTimeLabel } from "./time-options";
/** Quarter-hour time dropdown accepting custom 'HH:mm' entries for the datetime type. */
export function TimeSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    invalid = _ref.invalid,
    disabled = _ref.disabled,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var data = value && !TIME_OPTIONS.some(function (option) {
    return option.value === value;
  }) ? [{
    value: value,
    label: value
  }].concat(_toConsumableArray(TIME_OPTIONS)) : TIME_OPTIONS;
  return /*#__PURE__*/React.createElement(Select, {
    size: "sm",
    className: "w-24",
    placeholder: "HH:mm",
    "aria-label": t("time", {
      defaultValue: "Time"
    }),
    data: data,
    value: value,
    onChange: onChange,
    searchable: true,
    creatable: true,
    withinPortal: true,
    disabled: disabled,
    error: invalid,
    maxDropdownHeight: 240,
    getCreateLabel: function getCreateLabel(query) {
      return query;
    },
    shouldCreate: function shouldCreate(query) {
      return isValidTimeLabel(query);
    },
    onCreate: function onCreate(query) {
      onChange(query);
      return {
        value: query,
        label: query
      };
    },
    styles: HEADER_SELECT_STYLES,
    "data-testid": "".concat(testId, "-time")
  });
}